import React, {useEffect, useState} from "react";
import useIsPc from "hooks/useIsPc";
import introScreensaver from "assets/lotties/intro/introScreensaver.json";
import loopScreensaver from "assets/lotties/intro/loopScreensaver.json";
import tabletScreensaver from "assets/lotties/intro/tabletScreensaver.json";
import mobileScreensaver from "assets/lotties/intro/mobileScreensaver.json";
import screensaverTapToStart from "assets/lotties/intro/ScreensaverTapToStart_safari.json";
//import screensaverTapToStart from "assets/lotties/intro/screensaverTapToStart.json";
import Lottie from "lottie-react";
import useNavigation from "hooks/useNavigation";
import "./intro.css";
import useLottieRef from "hooks/useLottieRef";
import { useLayoutContext } from "../../layout/layout-provider";
import useIsMobile from "../../hooks/useIsMobile";
import useIsTablet from "../../hooks/useIsTablet";
import CustomLottie from "components/custom-lottie";
import {useFormContext} from "contexts/form/form-provider";
import {useScribeContext} from "../../contexts/scribe/scribe-provider";

const Intro: React.FC = () => {
  const [hideIntro, setHideIntro] = React.useState<boolean>(false);

  const isPC = useIsPc();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const { navigateToForm } = useNavigation();
  const {
    setIsPaused,
    setFirstLayerHidden,
    setSecondLayerHidden,
    setFirstLayerHomeHidden,
    setSecondLayerHomeHidden,
    setHeaderHidden,
    setFooterHidden,
      setShowQrAnimation,
  } = useLayoutContext();
  const {reset: resetScribe, setInitialized, reset, setShowQrCode,  setShowWritingAnimation, setSwitchToQrCodeScribe, } = useScribeContext();

  const { setInputValue } = useFormContext();

  useEffect(() => {
    setHeaderHidden(true);
    setFooterHidden(true);
    setFirstLayerHidden(true); //hidden
    setSecondLayerHidden(true); //hidden
    setFirstLayerHomeHidden(true);
    setSecondLayerHomeHidden(true);

    //TODO: scribe
    setInitialized(false);
    reset();

    setShowQrCode(false);//TODO: inizializza tutto
    setSwitchToQrCodeScribe(false); 

    setShowWritingAnimation(false);
  }, [reset, setFirstLayerHidden, setFooterHidden, setHeaderHidden, setInitialized, setIsPaused, setSecondLayerHidden, setShowQrCode, setShowWritingAnimation, setSwitchToQrCodeScribe, setFirstLayerHomeHidden, setSecondLayerHomeHidden]);

  useEffect(() => {
    setInputValue("");
  }, [setInputValue]);

  const [inactiveTimer, setInactiveTimer] = useState<NodeJS.Timeout | null>(null);

  // Rimuovi il timer quando il componente viene smontato
  useEffect(() => {
    return () => {
      if (inactiveTimer) {
        clearTimeout(inactiveTimer);
      }
    };
  }, [inactiveTimer]);

  const resetTimer = () => {
    if (inactiveTimer) {
      clearTimeout(inactiveTimer);
    }

    // Imposta un nuovo timer dopo 30 secondi di inattività
    const timer = setTimeout(() => {
      // Riavvia l'animazione intro
      setHideIntro(false);
    }, 30000);

    setInactiveTimer(timer);
  };

  const handleIntroClick = () => {
    // Quando viene cliccato sull'intro, avvia il timer
    resetTimer();
    navigateToForm();
  };

  return (
    <>
      {isPC && (
        <>
          {!hideIntro && (
            <CustomLottie
              animationData={introScreensaver}
              loop={false}
              autoplay={true}
              id={"intro-screensaver"}
              className="lottie-animation flex-grow-1"
              onComplete={() => {setHideIntro(true);  resetTimer();}}
              speed={0.5}
            />
          )}
          {hideIntro && (
            <CustomLottie
              animationData={loopScreensaver}
              loop={true}
              autoplay={true}
              id={"loop-screensaver"}
              className="lottie-animation flex-grow-1"
              onClick={handleIntroClick}
              speed={0.5}
            />
          )}
          <CustomLottie
            animationData={screensaverTapToStart}
            loop={true}
            autoplay={true}
            id={"screensaver-tap-to-start"}
            className="lottie-animation absolute bottom-0 origin-bottom width-50"
            onClick={handleIntroClick}
            speed={0.5}
          />
        </>
      )}
      {isTablet && (
        <CustomLottie
          animationData={tabletScreensaver}
          loop={false}
          autoplay={true}
          className="lottie-animation"
          onComplete={navigateToForm}
          speed={0.5}
        />
      )}

      {isMobile && (
        <CustomLottie
          animationData={mobileScreensaver}
          loop={false}
          autoplay={true}
          className="lottie-animation"
          onComplete={navigateToForm}
          speed={0.5}
        />
      )}
    </>
  );
};

export default Intro;
